<template>
  <div class="goods-detail-wrap">

    <!-- 加载失败 -->
    <div v-if="loadError" class="detail-status-wrap">
      <el-empty :description="$t('error')">
        <el-button size="small" class="btn-blue" @click="getDetail">{{ $t('retry') || '重试' }}</el-button>
      </el-empty>
    </div>

    <!-- 正常内容 -->
    <template v-else>
      <div class="goods-detail-head">
        <div class="goods-detail-left">
          <GoodsSwiper :list="details.albumList" :current="0" :currentSrc="sub.currentSrc"></GoodsSwiper>
        </div>
        <div class="goods-detail-right">
          <span class="goods-title text-row-2">{{ details.productInfo.goodsName }}</span>

          <div class="goods-detail-right-line detail-link-wrap align-center">
            <img class="detail-link-img" v-if="details.productInfo.platformType == '1688'" :src="img1688" alt="1688">
            <img class="detail-link-img" v-if="details.productInfo.platformType == 'taobao'" :src="imgTb" alt="taobao">
            <img class="detail-link-img" v-if="details.productInfo.platformType == 'jd'" :src="imgJd" alt="jd">
            <a class="detail-link" :href="details.productInfo.goodsUrl" rel="noreferrer" target="_blank">
              販売元の商品詳細へ（中国語ページ）<i class="el-icon-link"></i>
            </a>
          </div>

          <div class="goods-detail-right-line">{{ $t('cart.oneEight20') }}</div>

          <!-- 阶梯价格 -->
          <div v-if="details.str1688" class="od-pc-offer-price-common">
            <div class="price-content">
              <div class="price-header">
                <p style="line-height: 1.5em;">{{ $t('cart.wslang189') }}</p>
                <span>&nbsp;</span>
              </div>
              <div class="wrapper-ver-common">
                <div class="step-price-wrapper">
                  <div v-for="(item, idx) in details.str1688List" :key="idx" class="step-price-item">
                    <div style="color: #f40;line-height: 1.7em;">{{ item.price }}</div>
                    <div>{{ item.startQuantity }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 规格选择 -->
          <div class="goods-detail-right-line" v-for="(spu, index) in details.specificationList" :key="index">
            <div class="title-status">{{ spu.name }}</div>
            <radio-list
              space="10px"
              padding="10px"
              :parent="spu.name"
              :parentCn="spu.nameCn"
              :keys="index"
              @change="changeRadio"
              label="name"
              :list="spu.value"
            />
          </div>

          <!-- 价格展示 -->
          <div class="goods-detail-right-line flex-1 flex-row align-center">
            <div class="flex-1 align-center" style="min-height: 32px">
              {{ $t("cart.wslang189") }}：
              <span v-if="formData.goodsPrice" class="price-value-wrap">
                <span class="price-value-cn">{{ `${formatPrice(formData.goodsPrice)} ${$t('cart.wslang488')}` }}</span>
              </span>
            </div>
          </div>

          <!-- 数量 -->
          <div class="goods-detail-right-line">
            {{ $t("cart.wslang375") }}：
            <el-input-number size="mini" v-model="formData.goodsCount" :min="1" :max="99999" @change="handleChange" />
          </div>

          <!-- 操作按钮 -->
          <div class="goods-detail-right-btn flex-row">
            <el-button size="small" class="search-btn btn-green" @click="onAdd">{{ $t("cart.wslang187") }}</el-button>
            <el-button size="small" class="search-btn btn-gray" @click="reback">{{ $t("changeAccount.changeAccount20") }}</el-button>
          </div>
        </div>
      </div>

      <div class="detail-content">
        <div v-if="details.attrList.length > 0" class="common-card goods-info-details-card">
          <div class="goods-info-details-title">{{ $t('cart.wslang347') }}</div>
          <div class="goods-info-details-grid">
            <div v-for="item in details.attrList" :key="item.name" class="goods-info-details-item">
              <span class="goods-info-details-label">{{ item.name }}</span>
              <span class="goods-info-details-content">{{ item.value }}</span>
            </div>
          </div>
        </div>
        <div class="common-card goods-v-html-info">
          <div class="card-title">{{ $t('cart.wslang608') }}</div>
          <div class="vhtml" v-html="details.productInfo.detailHtml"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import GoodsSwiper from './cmp/goods-swiper.vue'
import RadioList from './cmp/radio-list.vue'
import { generatePriceRangeText, formatPricingzh, formatPrice, get1688Price } from '@/utils/utils'
import img1688 from '@/assets/images/1688.png'
import imgTb from '@/assets/images/tb.png'
import imgJd from '@/assets/images/jd.png'

const EMPTY_DETAILS = () => ({
  albumList: [],
  attrList: [],
  skuList: [],
  specificationList: [],
  priceRangeList: [],
  str1688: null,
  str1688List: [],
  productInfo: {
    goodsName: undefined, goodsNameCn: undefined, goodsUrl: undefined,
    detailHtml: undefined, picUrl: undefined, shopName: undefined, platformType: undefined,
  },
})

export default {
  components: { GoodsSwiper, RadioList },
  data() {
    return {
      loading: false,
      loadError: false,
      details: EMPTY_DETAILS(),
      sub: { spData: [], spDataCn: [], currentSrc: undefined, priceObj: undefined },
      formData: {
        goodsCount: 1,
        goodsPrice: undefined,
        goodsImageUrl: undefined,
        goodsName: undefined,
        goodsNameCn: undefined,
        goodsUrl: undefined,
        platformType: undefined,
        shopName: undefined,
        goodsSize: undefined,
        colour: undefined,
        goodsSpecs: undefined,
        goodsSpecsCn: undefined,
      },
      offerId: '',
      sellerOpenId: '',
      img1688, imgTb, imgJd,
      formatPrice,
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.loading = true
      this.loadError = false
      try {
        const res = await this.$http.get('order/getGoodsInfo', { params: { url: this.$route.query.goodsUrl } })
        if (res.data.code === 200) {
          const d = res.data.data
          this.details = {
            albumList: d.albumList?.length ? d.albumList : [{ picPath: d.picUrl }],
            attrList: d.attrList || [],
            skuList: d.skuList || [],
            specificationList: (d.specificationList || []).map(v => ({ ...v, name: v.name.trim() })),
            priceRangeList: [],
            str1688: null,
            str1688List: [],
            productInfo: {
              goodsUrl: d.detailUrl,
              goodsName: d.goodsNameCn,
              goodsNameCn: d.goodsNameCn,
              detailHtml: d.desc,
              picUrl: d.picUrl,
              shopName: d.shopName,
              platformType: d.platformType,
            },
          }
          if (d.priceRangeList?.length > 1) {
            this.details.priceRangeList = d.priceRangeList
            this.details.str1688 = generatePriceRangeText(d.priceRangeList)
            this.details.str1688List = formatPricingzh(d.priceRangeList)
          }
          this.offerId = d?.offerId || ''
          this.sellerOpenId = d?.sellerOpenId || ''
          this.formData.goodsName = this.details.productInfo.goodsName
          this.formData.goodsNameCn = this.details.productInfo.goodsNameCn
          this.formData.goodsUrl = this.details.productInfo.goodsUrl
          this.formData.platformType = this.details.productInfo.platformType
          this.formData.shopName = this.details.productInfo.shopName
          this.formData.goodsImageUrl = this.details.productInfo.picUrl
        } else {
          this.loadError = true
        }
      } catch (e) {
        console.error('getDetail error:', e)
        this.loadError = true
      } finally {
        this.loading = false
      }
    },

    // 根据 priceObj 和数量计算最终价格
    resolvePrice(priceObj, count) {
      if (!priceObj) return undefined
      const { str1688, priceRangeList } = this.details
      if (str1688 && priceRangeList?.length > 1) {
        return get1688Price(priceRangeList, count) || priceObj.price
      }
      return priceObj.price
    },

    changeRadio(item) {
      const { keys, parent, parentCn } = item
      this.sub.spData[keys] = `${parent}:${item.item.name}`
      this.sub.spDataCn[keys] = `${parentCn}:${item.item.nameCn}`

      if (item.item?.url) {
        this.formData.goodsImageUrl = item.item.url
        this.sub.currentSrc = item.item.url
      } else {
        this.sub.currentSrc = undefined
      }

      // SKU 匹配
      const selectedSpecs = this.sub.spData.filter(Boolean)
      this.sub.priceObj = this.details.skuList.find(sku => {
        if (!sku.properties_name?.length) return false
        if (selectedSpecs.length !== sku.properties_name.length) return false
        return selectedSpecs.every(spec => {
          const [name, value] = spec.split(':')
          return sku.properties_name.some(p => p.name === name && p.value === value)
        })
      })

      // 价格计算
      this.formData.goodsPrice = this.resolvePrice(this.sub.priceObj, this.formData.goodsCount)

      // 同步规格到 formData
      this.formData.colour = this.sub.spData[0]
      this.formData.goodsSize = this.sub.spData[1]
      this.formData.goodsSpecs = this.sub.spData.join(';')
      this.formData.goodsSpecsCn = this.sub.spDataCn.join(';')
    },

    handleChange(count) {
      if (this.sub.priceObj && this.details.str1688) {
        this.formData.goodsPrice = this.resolvePrice(this.sub.priceObj, count)
      }
    },

    async onAdd() {
      if (!this.sub.priceObj) {
        this.$message.error(this.$t('createOrder.createOrder125'))
        return
      }
      try {
        const addRes = await this.$http.post('shopping/vehicle/addOne')
        if (addRes.data.code !== 200 || !addRes.data.data?.id) {
          this.$message.error(addRes.data.message || this.$t('error'))
          return
        }
        const payload = {
          id: addRes.data.data.id,
          trackingNumber: '',
          taobaoUrl: this.formData.goodsUrl,
          goodsName: this.formData.goodsName,
          colour: this.formData.colour?.split(':')[1] ?? this.formData.colour,
          goodsSize: this.formData.goodsSize?.split(':')[1] ?? this.formData.goodsSize,
          goodsCount: this.formData.goodsCount,
          price: this.formData.goodsPrice,
          pictureUrl: this.formData.goodsImageUrl,
          goodsNumber: '',
          agentFlag: '1',
          orderType: '1',
          fnsku: '',
          goodsNameCus: '',
          asin: '',
          checkProjectArray: ['baseCheck'],
          inspectionFileName: '',
          inspectionFileUrl: '',
          laundryLabelId: null,
          customerRemark: '',
          autoSendFlag: '0',
          skuId: this.sub.priceObj?.sku_id,
          specId: this.sub.priceObj?.specId,
          offerId: this.offerId,
          sellerOpenId: this.sellerOpenId,
        }
        const updateRes = await this.$http.post('shopping/vehicle/update', payload)
        if (updateRes.data.code === 200) {
          this.$message.success(this.$t('cart.applyMessage35'))

        } else {
          this.$message.error(updateRes.data.message || this.$t('error'))
        }
      } catch (e) {
        this.$message.error(this.$t('error'))
      }
    },

    reback() {
      this.$router.push({ name: 'Cart' })
    },
  },
}
</script>

<style lang="less" scoped>
.goods-detail-wrap {
  width: 100%;
  height: 100%;
  padding: 10px;
  background: var(--bg-card);
  border-radius: 5px;
  overflow: auto;

  .detail-status-wrap {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .goods-detail-head {
    display: flex;

    .goods-detail-right {
      flex-grow: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .goods-title {
        font-size: 20px;
        color: var(--text-main);
        margin-top: 0;
      }

      .title-status {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 20px;
      }

      .od-pc-offer-price-common {
        width: 100%;
        .price-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 8px 16px 12px;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
          background-color: var(--price-card-bg);

          .price-header {
            display: flex;
            flex-direction: column;
            min-width: 60px;
            max-width: 140px;
            margin-right: 10px;
            white-space: nowrap;
          }

          .wrapper-ver-common {
            flex: 1;
            .step-price-wrapper {
              display: flex;
              flex-direction: row;
              align-items: flex-end;
              gap: 24px;
              .step-price-item {
                white-space: nowrap;
                min-width: 110px;
                max-width: 170px;
              }
            }
          }
        }
      }

      .goods-detail-right-line { font-size: 14px; line-height: 20px; }
      .detail-link-wrap { gap: 6px; }
      .detail-link { text-decoration: none; font-size: 12px; color: #1f6feb; }

      .price-value-wrap {
        display: flex;
        gap: 20px;
        align-items: center;
        padding: 0 10px;
        .price-value-cn { font-size: 26px; color: #FF691F; font-weight: bold; }
      }
    }
  }

  .flex-1 { flex: 1; }
  .flex-row { display: flex; flex-direction: row; }
  .align-center { align-items: center; }

  .common-card { width: 100%; padding: 20px; border-radius: 10px; }

  .goods-info-details-card {
    background: var(--goods-card);
    border: 1px solid var(--goods-border-color);
    .goods-info-details-title {
      color: var(--text-main);
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 16px;
    }

    .goods-info-details-grid {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      border-top: 1px solid var(--goods-border-color);
      border-left: 1px solid var(--goods-border-color);
    }

    .goods-info-details-item {
      display: flex;
      min-height: 40px;
      border-right: 1px solid var(--goods-border-color);
      border-bottom: 1px solid var(--goods-border-color);
    }

    .goods-info-details-label,
    .goods-info-details-content {
      display: flex;
      align-items: center;
      padding: 8px 10px;
      word-break: break-word;
    }

    .goods-info-details-label {
      width: 38%;
      color: var(--des-label);
      background: var(--price-card-bg);
    }

    .goods-info-details-content {
      flex: 1;
      color: var(--des-content);
    }
  }

  .goods-v-html-info {
    background: var(--goods-card);
    border: 1px solid var(--goods-border-color);
    .card-title { font-size: 16px; font-weight: 700; color: var(--text-main); }
  }

  .detail-content { display: flex; flex-direction: column; gap: 16px; margin-top: 16px; }

  .vhtml {
    max-width: 100%;
    word-wrap: break-word;
    overflow: hidden;
    padding: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    :deep(p) { max-width: 100%; word-wrap: break-word; overflow: hidden; }
    :deep(img) { display: inline; width: 100%; font-size: 0px; }
  }
}

@media screen and (max-width: 768px) {
  .goods-detail-wrap {
    overflow-x: hidden;
    .goods-detail-head {
      flex-wrap: wrap;
      .goods-detail-right {
        margin-top: 10px;
        width: 100%;
        .price-content { overflow-x: auto; }
        .step-price-wrapper { gap: 10px; }
        .price-header { min-width: 40px !important; }
        .step-price-item { min-width: 20px !important; }
      }
    }
    .vhtml :deep(*) { width: 100% !important; }
    .goods-info-details-grid { grid-template-columns: 1fr; }
  }
}
</style>
